import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

/**
 * Open PDFs in new window
 */
function linksCustomization(){
	var pdfLinks = document.querySelectorAll('a[href$=".pdf"]')

	pdfLinks.forEach(pdf => {
		pdf.setAttribute('target', '_blank');
	});
}

/**
 * Adds smooth scrolling to anchor links
 * 
 * Adds data-scroll-to attribute to anchor links without it.
 */
function scrollTo(lenis){
	// Function to handle smooth scrolling for anchor links
	function smoothScroll(targetSelector, offset = 0) {
		const element = document.querySelector(targetSelector);

		if (element) {
			// Get the target scroll position
			const targetY = element.getBoundingClientRect().top + window.scrollY - offset;

			// Use Lenis to scroll
			lenis.scrollTo(targetY, {
				duration: 1.2,   // seconds
				easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)) // match your Lenis easing
			});
		}
	}

	// Detect all anchor links without your special attributes
	const scrollToLinks = document.querySelectorAll('a[href^="#"]:not([data-scroll]):not([data-fancybox])');
	scrollToLinks.forEach(link => {
		if (link.getAttribute('href').length > 1) {
		link.setAttribute('data-scroll', 'scroll-to');
		}
	});

	// Event listener for anchor links
	const anchorLinks = document.querySelectorAll('[data-scroll="scroll-to"]');
	anchorLinks.forEach(element => {
		element.addEventListener('click', function(event) {
			event.preventDefault();

			const target = event.currentTarget;

			let offset = 50; // Default offset
			if (target.getAttribute('data-scroll-space')) {
				offset = parseInt(target.getAttribute('data-scroll-space'), 10);
			}

			smoothScroll(target.getAttribute('href'), offset);
		});
	});
}


/**
 * Adds a class to tablepress tables to make them responsive.
 */
function responsiveTables(){
	if ( document.querySelectorAll('.prose table').length > 0 ) {
		const tables = document.querySelectorAll('.prose table');

		var wrap = function (toWrap, wrapper) {
			wrapper = wrapper || document.createElement('div');
			wrapper.classList.add('responsive-table');
			
			// Insert the wrapper before the toWrap element
			toWrap.parentNode.insertBefore(wrapper, toWrap);
			
			return wrapper.appendChild(toWrap);
		};

		[...tables].forEach((table) => {
			wrap(table);
		});
	}
}

function factCircle() {
	const factCircle = document.querySelectorAll('[data-name="fact-circle"]');

	if ( factCircle.length === 0 ) return;

	factCircle.forEach(circle => {
		const textVisible = circle.querySelector('[data-name="fact-circle__text-visible"]');
		const textInvisible = circle.querySelector('[data-name="fact-circle__text-invisible"]');

		// On mouse hover
		circle.addEventListener('mouseenter', () => {
			gsap.to( textVisible, {  autoAlpha: 0, duration: 0.3, overwrite: true } );
			gsap.to( textInvisible, { autoAlpha: 1, duration: 0.5, overwrite: true });
		});

		// On mouse leave
		circle.addEventListener('mouseleave', () => {
			gsap.to( textVisible, {  autoAlpha: 1, duration: 0.3, overwrite: true } );
			gsap.to( textInvisible, { autoAlpha: 0, duration: 0.5, overwrite: true });
		});
	});
}

function countUp(){
	const counters = document.querySelectorAll('[data-name="count-up"]');

	if ( counters.length === 0 ) return;

	counters.forEach(counter => {
		// Get the text content and clean it
		const textContent = counter.textContent.trim();
		const endValue = parseInt(textContent, 10);

		// Skip if not a valid number
		if (isNaN(endValue)) {
			console.warn('countUp: Invalid number in counter element', counter);
			return;
		}

		// Create ScrollTrigger animation
		gsap.fromTo(counter,
			{
				innerText: 0
			},
			{
				innerText: endValue,
				duration: 2.5,
				ease: 'power2.out',
				snap: { innerText: 1 },
				onUpdate: function() {
					counter.innerText = Math.round(counter.innerText);
				},
				scrollTrigger: {
					trigger: counter,
					start: 'top bottom-=100px',
					once: true,
				}
			}
		);
	});
}


export { linksCustomization, scrollTo, responsiveTables, factCircle, countUp };
